import React from 'react'
import t from 'prop-types'
import { css } from 'linaria'
import cx from 'classnames'

import WYSIWYG from '../../WYSIWYG'
import ButtonPrimary from '../../Links/ButtonPrimary'
import { Link } from 'gatsby'

const wysiwygCSS = css`
  & > div {
    p,
    ul,
    ol,
    li {
      @apply font-bold text-2xl !important;

      strong {
        @apply font-normal !important;
      }
    }
  }
`

const PillarCTA = ({ data }) => {
  return (
    <div className="pillar-cta my-16 lg:my-20 pb-16 lg:pb-20 px-5 lg:px-0 border-b-4 border-gray-700 max-w-screen-md mx-auto">
      {data.content && (
        <div
          className={cx(`${wysiwygCSS} pillar-content__wysiwyg`, {
            'mb-8': data.button?.url && data.button?.title,
          })}
        >
          <WYSIWYG content={data.content}></WYSIWYG>
        </div>
      )}
      {data.button?.url && data.button?.title && (
        <ButtonPrimary as={Link} {...data.button}>
          {data.button.title}
        </ButtonPrimary>
      )}
    </div>
  )
}

PillarCTA.propTypes = {
  data: t.object,
}

PillarCTA.defaultProps = {}

export default PillarCTA
